import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAppointment: true,
  isFollowUp: true
};
const roleSlice = createSlice({
  name: 'roleSlice',
  initialState,
  //   reducer needs a map
  reducers: {
    setAppointment(state, action) {
      state.isAppointment = action.payload;
    },
    setFollowUp(state, action) {
      state.isFollowUp = action.payload;
    }
  }
});
export const { setAppointment, setFollowUp } = roleSlice.actions;
export default roleSlice.reducer;
